









































import Vue from "vue";
import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import VipVideo from "./VipVideo.vue";
import VipOfferUtils from "@/utils/vipOfferUtils";
import VipButton from "./VipButton.vue";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";
import GeneralUtils from "@/utils/generalUtils";

@Component({
  components: { VipButton, VipVideo }
})
export default class VipBTabPage extends Vue {
  get selectOffer() {
    return VipOfferUtils.firstVipService();
  }

  get vipBenefitsList() {
    return [
      {
        icon: require("@/assets/icons-file/store_vip/store_vip_benefit_follower.png"),
        title: "Get 10 bonus followers every day",
        count: 30
      },
      {
        icon: require("@/assets/icons-file/store_vip/store_vip_benefit_coins.png"),
        title: "+1,000 bonus coins as a gift",
        count: 1
      },
      {
        icon: require("@/assets/icons-file/store_vip/store_vip_benefit_order.png"),
        title: "10% more on all 👤 ❤️ orders",
        count: 1
      },
      {
        icon: require("@/assets/icons-file/store_vip/store_vip_benefit_packs.png"),
        title: "4 super big discount coins packs",
        count: 4
      },
      {
        icon: require("@/assets/icons-file/store_vip/store_vip_benefit_drop.png"),
        title: "No followers drop guaranteed",
        count: 1
      },
      {
        icon: require("@/assets/icons-file/store_vip/store_vip_benefit_active.png"),
        title: "More active & real followers",
        count: 1
      },
      {
        icon: require("@/assets/icons-file/store_vip/store_vip_benefit_speed.png"),
        title: "300% higher-speed growth",
        count: 1
      },
      {
        icon: require("@/assets/icons-file/store_vip/store_vip_benefit_personal.png"),
        title: "24/7 personal consultant",
        count: 1
      },
      {
        icon: require("@/assets/icons-file/store_vip/store_vip_benefit_ads.png"),
        title: "Remove ADS",
        count: 1
      }
    ];
  }

  private initData() {
    sendEventWithParams("uia_vip_other_show", { place: "tab4" });
  }

  get isVIP() {
    return GeneralUtils.isVip();
  }

  private activated() {
    this.initData();
  }

  private created() {}

  private mounted() {
    this.initData();
  }

  private beforeDestroy() {}
}
